<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="onlineDisplay">
    <v-dialog
      v-model="examNotOnlineDialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="font-weight-light text-xs-left title underlineheadline bluetext mb-0"
          primary-title
        >
          Prüfungsinformationen
        </v-card-title>

        <v-card-text v-if="currentGroup">
          <span class="caption" style="color:red">
            Diese Prüfung ist nicht online.
          </span><br>
          <span class="caption">
            Diese Prüfung war bzw. ist online<br>
            von {{new Date(currentGroup.onlineStart)}}
            <br>
            bis {{new Date(currentGroup.onlineEnd)}}
          </span><br>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="examenis" dark outline
            class="font-weight-bold radiusBtn text-none"
            @click="resetLogin()"
          >
            Verstanden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="tanIsNotActiveDialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="font-weight-light text-xs-left title underlineheadline bluetext mb-0"
          primary-title
        >
          Prüfungsinformationen
        </v-card-title>

        <v-card-text v-if="currentGroup">
          <span class="caption" style="color:red">
            Ihre Teilnehmer TAN ist nicht aktiv geschaltet.
          </span><br><br>
          <span class="caption">
            Diese Prüfung war bzw. ist online<br>
            von {{new Date(currentGroup.onlineStart)}}
            <br>
            bis {{new Date(currentGroup.onlineEnd)}}
          </span><br>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="examenis" dark outline
            class="font-weight-bold radiusBtn text-none"
            @click="resetLogin()"
          >
            Verstanden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="error"
      width="500"
    >
      <v-card>
        <v-card-title v-if="errorItem"
          class="font-weight-light text-xs-left title underlineheadline bluetext mb-0"
          primary-title
        >
          Prüfungsmeldung {{errorItem.code}}
        </v-card-title>

        <v-card-text v-if="errorItem">
          <span class="caption" style="color:red">
            {{errorItem.message}}
          </span>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="examenis" dark outline
            class="font-weight-bold radiusBtn text-none"
            @click="closeErrorDialog(errorItem)"
          >
            Verstanden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="loginAlreadyDoneDialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="font-weight-light text-xs-left title underlineheadline bluetext mb-0"
          primary-title
        >
          Prüfungsinformationen
        </v-card-title>

        <v-card-text v-if="currentGroup">
          <span class="caption" style="color:red">
            Sie durften sich für die Prüfung nur einmalig anmelden. Eine weitere Anmeldung ist nicht möglich.
          </span><br>
          <span class="caption" v-if="currentGroup.zeitlimit > 0">
            Sie hatten für die Beantwortung der Fragen <span style="color:green; font-weight: bold;">{{currentGroup.zeitlimit}}</span> Minuten Zeit.
          </span><br>
          <span class="caption" v-if="currentGroup.zeitlimit === 0">
            Sie hatten für die Beantwortung der Fragen kein Zeitlimit.
          </span>
          <span class="caption" v-if="!limitLogin">
            In der Bearbeitungszeit darf man sich erneut anmelden.
          </span>

        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="examenis" dark outline
            class="font-weight-bold radiusBtn text-none"
            @click="resetLogin()"
          >
            Verstanden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="contractDialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="font-weight-light text-xs-left title underlineheadline bluetext mb-0"
          primary-title
        >
          Zustimmung erforderlich
        </v-card-title>
        <v-card-text class="text-left text-xs-left">
          Sie müssen zuerst den Bedingungen zustimmen bevor sie fortfahren können.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="examenis" dark outline
            class="font-weight-bold radiusBtn text-none"
            @click="contractDialog = false"
          >
            Verstanden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="infoDialog"
      width="640"
    >
      <v-card>
        <v-card-title
          class="font-weight-light text-xs-left title underlineheadline bluetext mb-0"
          primary-title
        >
          Prüfungsinformationen
        </v-card-title>

        <v-card-text v-if="currentGroup" class="text-left text-xs-left">
          <span class="caption font-weight-bold" v-if="currentGroup.zeitlimit > 0">
            Sie haben für die Beantwortung der Fragen ab sofort <span style="color:green; font-weight: bold;">{{currentGroup.zeitlimit}}</span> Minuten Zeit.
          </span><br>
          <span class="caption font-weight-bold" v-if="currentGroup.zeitlimit === 0">
          Sie haben für die Beantwortung der Fragen kein Zeitlimit.
          </span>
          <span class="caption font-weight-bold" v-if="!limitLogin">
          In der Bearbeitungszeit darf man sich erneut anmelden.
          </span>
          <br>
          <div v-if="currentGroup.anweisung" class="text-left pt-4">
            <span style="font-weight: bold"> Hinweise:</span><br>
            <span class="font-weight-regular" v-html="currentGroup.anweisung"></span>
          </div>
          <div v-if="currentGroup.bemerkung" class="text-left pt-4">
            <span style="font-weight: bold"> Anmerkung:</span><br>
            <span class="font-weight-regular" v-html="currentGroup.bemerkung"></span>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="examenis" dark outline
            class="font-weight-bold radiusBtn text-none"
            @click="infoDialog = false"
          >
            Verstanden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="lastDialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="font-weight-light text-xs-left title underlineheadline bluetext mb-0"
          primary-title
        >
          {{lastDialogTitle}}
        </v-card-title>
        <v-card-text>
          {{ lastDialogTitleDesc }}
        </v-card-text>
        <v-card-text v-if="cntTodos === 0">
          Alle Angaben sind gespeichert.
          Sie können das Fenster nun schlie&szlig;en.
        </v-card-text>
        <v-card-text v-if="cntTodos !== 0">
          Bitte haben Sie noch etwas Geduld. Es werden noch Antworten gespeichert.
          <br>
          <v-progress-linear
            color="success"
            height="18"
            :value="(100.0 / (maxToDos + 1) * 1.0) * ((maxToDos - cntTodos) + 1)"
          >({{ ((maxToDos - cntTodos) + 1)}} / {{maxToDos + 1}})</v-progress-linear>
          <br>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn
            v-if="lastDialogCancelAllowed"
            color="black" dark outline
            class="font-weight-bold radiusBtn text-none"
            @click="lastDialog = false"
          >
            {{lastDialogCancelBtnText}}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="cntTodos === 0"
            color="examenis" dark outline
            class="font-weight-bold radiusBtn text-none"
            @click="close()"
          >
            Jetzt beenden
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="maxOnlineDisplay">
    <div class="previewTitleHolder" v-if="currentGroup !== null && questionData !== null && items">
      <v-layout wrap>
        <v-flex xs10>
          <div  :title="currentGroup.ID_Klausur" :hint="currentGroup.ID_Klausur" class="font-weight-light text-xs-left headline miniTitle2 underlineheadline bluetext mb-1 pa-3">{{currentGroup.Titel}}</div>
        </v-flex>
        <v-flex xs2 class="text-xs-right">
          <v-btn flat icon @click="closeOnline" color="examenis">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs10 class="text-xs-left bluetext" style="border-bottom: #043073 1px solid">
            {{questionData.frage}} <span v-if="items != null"> Frage <span style="font-weight: bolder" class="display-1">{{questionIndex + 1}}</span> / {{items.length}}</span>
            <span class="caption"> Mögliche Punkte: {{Punkte}}&emsp; Antwortmöglichkeiten: {{answeroptions}}</span>
            <span class="caption" v-if="currentGroup.zeitlimit > 0 && (!(secRemaining !== -999))">&nbsp; Zeitlimit: {{currentGroup.zeitlimit}} Minuten</span>
            <span class="caption" v-if="currentGroup.zeitlimit > 0 && (secRemaining !== -999)">&nbsp; verbleibend {{remainStr}}</span>
            <span class="caption" v-if="userData && userData.Nachname">Teilnehmer: {{userData.Nachname}},</span>
            <span class="caption" v-if="userData && userData.Vorname">{{userData.Vorname}}</span>
        </v-flex>
        <v-flex xs2 class="text-xs-right" style="border-bottom: #043073 1px solid">
          <v-icon :color="getColorWifi()">wifi</v-icon>

        </v-flex>
      </v-layout>
    </div>
    <simplebar ref="simpleBar" name="sb" data-simplebar-auto-hide="false" class="edobar previewHolder" v-if="(questionData !== null) && (!loginAlreadyDoneDialog) && (!examNotOnlineDialog)">
      <PreviewItem ref="pItemRoot" :qIndex="questionIndex + 1" :indexOfFirstText="getFirstTextIndex(questionData)" @updateValue="updateValue" :nodeId="getRootNodeId(questionData)" :itemId="itemId" :previewData="questionData" :isOnline="true"></PreviewItem>
      <PreviewItem :qIndex="questionIndex + 1" :indexOfFirstText="getFirstTextIndex(child)" class="upset" @updateValue="updateValue" :nodeId="(ci + 1)" :itemId="child.id" :previewData="child" v-if="questionData.childs && child" :isOnline="true" v-for="(child, ci) in questionData.childs" v-bind:key="ci"></PreviewItem>
    </simplebar>
    <div class="onlineFooter" v-if="items !== null">
      <v-layout class="pa-0" v-if="items">
        <v-btn v-if="questionIndex !== 0" @click="prev()" color="black" dark large outline
               class="font-weight-bold text-none">zurück
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="questionIndex < (items.length - 1) && forwardEnabled" @click="forward()" color="examenis" dark large depressed class="font-weight-bold text-none">weiter</v-btn>
        <v-btn v-if="questionIndex < (items.length - 1) && (!forwardEnabled)" @click="forward()" color="examenisDisabled" dark large depressed class="font-weight-bold text-none">weiter</v-btn>
        <v-btn v-if="questionIndex === (items.length - 1)" @click="closeOnline()" color="examenis" dark large depressed outline class="font-weight-bold text-none">Beenden
        </v-btn>
      </v-layout>
    </div>
    </div>
  </div>
  <!--
  <v-container fluid>
    <v-dialog
      v-model="lastDialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="font-weight-light text-xs-left title underlineheadline bluetext mb-0"
          primary-title
        >
          Letze Frage erreicht
        </v-card-title>

        <v-card-text>
          Alle Angaben werden bereits beim ausfüllen gespeichert. Sie können das Fenster jederzeit schliessen sobald Sie fertig sind.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="examenis" dark small round outline
            class="font-weight-bold radiusBtn text-none"
            @click="lastDialog = false"
          >
            Schliessen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-container class="pt-0">
      <v-flex xs12>
        <v-layout class="font-weight-light text-xs-left headline underlineheadline bluetext mb-0 pa-3">
          Online Prüfung
          {{currentGroup.ID_Klausur}} {{currentGroup.titel}}
         -->
         <!-- <v-spacer></v-spacer>
          Autor: {{currentGroup.Autor}}-->
  <!--
        </v-layout>
      </v-flex>
      <v-layout row justify-center class="mt-5">
        <v-flex xs12>
          <v-card v-if="questionData!=null" flat color="white" max-height="600" min-height="600">
            <v-layout row justify-center wrap>
              <v-flex xs10 class="text-xs-left" style="border-bottom: #043073 1px solid">
                <v-card-text class="font-weight-light text-xs-left title uppercase bluetext">
                  {{questionData.frage}} <span v-if="items != null"> Frage <span style="font-weight: bolder" class="display-1">{{questionIndex + 1}}</span> / {{items.length}}</span>
                  <br>
                   <span class="caption"> Mögliche Punkte: {{questionData.Punkte}}&emsp; Antwortmöglichkeiten: {{answeroptions}}</span>
                </v-card-text>
              </v-flex>
              <v-flex xs2 class="text-xs-right" style="border-bottom: #043073 1px solid">
                <v-btn flat icon @click="close" color="examenis">
                  <v-icon>clear</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
            <v-card-text>
              <v-messages v-if="error">
                Es ist ein Fehler aufgetreten. Bitte stellen sie eine Internetverbindung her und öffnen die Teilnahme
                erneut.
              </v-messages>
              <simplebar data-simplebar-auto-hide="false" style="top:100px;bottom:100px;position: absolute;">
              <PreviewItem @updateValue="updateValue" :itemId="itemId" :previewData="questionData"></PreviewItem>
              </simplebar>
            </v-card-text>
            -->
            <!--<v-card-actions v-if="items != null">
              <v-btn v-if="questionIndex != 0" @click="prev()" color="grey" dark small round outline
                     class="font-weight-bold radiusBtn text-none">zurück
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn v-if="questionIndex < (items.length - 1)" @click="forward()" color="examenis" dark small round
                     outline
                     class="font-weight-bold radiusBtn text-none">weiter
              </v-btn>
              <v-btn v-if="questionIndex === (items.length - 1)" @click="closeOnline()" color="examenis" dark small
                     round outline
                     class="font-weight-bold radiusBtn text-none">Letzte Frage erreicht
              </v-btn>
            </v-card-actions>-->
  <!--
          </v-card>

          <v-footer class="pa-2 px-5" fixed height="65" v-if="items != null" color="#fafafa">
            <v-btn v-if="questionIndex != 0" @click="prev()" color="black" dark large outline
                   class="font-weight-bold text-none" style="margin-left: 4em">zurück
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="questionIndex < (items.length - 1)" @click="forward()" color="examenis" dark large depressed
                   class="font-weight-bold text-none" style="margin-right: 4em">weiter
            </v-btn>
            <v-btn v-if="questionIndex === (items.length - 1)" @click="closeOnline()" color="examenis" dark large
                   outline
                   class="font-weight-bold text-none" style="margin-right: 4em">Beenden
            </v-btn>
          </v-footer>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
  -->
</template>

<script>
  import Vue from 'vue'
  import PreviewItem from '../widgets/PreviewItem'
  import simplebar from 'simplebar-vue'
  import 'simplebar/dist/simplebar.min.css'
  export default {
    name: 'online',
    components: {PreviewItem, simplebar},
    methods: {
      getFirstTextIndex: function (item) {
        let index = 2
        try {
          for (var qIndex in item.contents) {
            var content = item.contents[qIndex]
            if (content.Zeile >= 1) {
              if (content.Format === 'TXT') {
                index = content.Zeile
              }
            }
            if (content.Zeile >= 2) {
              if (content.Format === 'TXT') {
                index = content.Zeile
                break
              }
            }
          }
        } catch (ee) {

        }
        return index
      },
      getRootNodeId: function (item) {
        if (item.childs && item.childs.length > 0) {
          return 0
        }
        return null
      },
      close: function () {
        let cmp = this
        if (cmp.myTimer) {
          window.clearTimeout(cmp.myTimer)
          cmp.myTimer = null
        }
        var logoutData = {
          idKlausur: this.currentGroupId
        }
        Vue.prototype.$apiParticipant.logout(logoutData, this.onLogOut, this.onLogOut)
      },
      onLogOut: function () {
        this.$router.push('/' + Vue.prototype.$api.cssName)
      },
      resetLogin: function () {
        this.loginAlreadyDoneDialog = false
        this.currentGroup = null
        this.$router.push('/' + Vue.prototype.$api.cssName)
      },
      getColorWifi: function () {
        let color = 'green'
        if (this.hasNetworkItem) {
          color = 'orange'
          if (Vue.prototype.$apiParticipant.getCountTodos() > 10) {
            color = 'red'
          }
        }
        return color
      },
      forward: function () {
        if (this.questionData.Typ === '101') {
          if (!this.forwardEnabled) {
            this.contractDialog = true
            return
          }
        }
        this.questionIndex++
        if (this.questionIndex > this.items.length - 1) this.questionIndex = this.items.length - 1
        this.itemId = this.items[this.questionIndex].ID
        Vue.prototype.$apiParticipant.ping({
          itemId: this.itemId
        }, this.onPingSuccess, this.onAnswerFailed)
        this.load()
      },
      prev: function () {
        this.questionIndex--
        if (this.questionIndex < 0) this.questionIndex = 0
        this.itemId = this.items[this.questionIndex].ID
        Vue.prototype.$apiParticipant.ping({
          itemId: this.itemId
        }, this.onPingSuccess, this.onAnswerFailed)
        this.load()
      },
      closeOnline: function () {
        if (this.lastDialog) {
          return
        }
        this.lastDialog = true
        this.maxToDos = Vue.prototype.$apiParticipant.getCountTodos()
      },
      onGetItem: function (data) {
        if (data) {
          this.questionData = data
          try {
            if (this.questionData.Typ !== '101') {
              this.forwardEnabled = true
            }
          } catch (ee) {

          }
          this.dialog = true
          this.itemId = data.ID
          this.answeroptions = 0
          this.Punkte = 0
          try {
            this.Punkte = this.questionData.Punkte
            for (var index in this.questionData.contents) {
              var content = this.questionData.contents[index]
              if (content.Format === 'ANX') {
                this.answeroptions++
              }
            }
            if (this.questionData.childs) {
              for (var index22 in this.questionData.childs) {
                var childQuestion = this.questionData.childs[index22]
                try {
                  for (var i2 in childQuestion.contents) {
                    var c2 = childQuestion.contents[i2]
                    if (c2.Format === 'ANX') {
                      this.answeroptions++
                    }
                  }
                } catch (ef) {
                }
                try {
                  this.Punkte = this.Punkte * 1 + childQuestion.Punkte * 1
                } catch (ef) {
                }
              }
            }
          } catch (e) {
            console.log(e)
          }
        }
        if (!this.currentGroup.isOnline) {
          this.examNotOnlineDialog = true
        } else {
          if (Vue.prototype.$api.getCredentials() && Vue.prototype.$api.getCredentials().data) {
            if (!Vue.prototype.$api.getCredentials().data.isTanActiv) {
              this.tanIsNotActiveDialog = true
              return
            }
          }
          if (Vue.prototype.$api.getCredentials() && Vue.prototype.$api.getCredentials().data) {
            if (Vue.prototype.$api.getCredentials().data.alreadyStarted) {
              this.infoDialogNotShown = false
            }
            if (Vue.prototype.$api.getCredentials().data.userTooLate) {
              this.loginAlreadyDoneDialog = true
              this.dialog = false
              return
            }
          }
        /*
        if (Vue.prototype.$api.stringToBoolean(this.currentGroup.options.limitLogin)) {
          if (this.participanData && Vue.prototype.$api.stringToBoolean(this.currentGroup.TAN_benutzt)) {
            this.loginAlreadyDoneDialog = true
            this.dialog = false
          }
        } else {
          this.infoDialog = true
        }
           */
          if (this.infoDialogNotShown) {
            this.infoDialog = true
            this.infoDialogNotShown = false
          }
        }
        let cmp = this
        this.$nextTick(function () {
          cmp.checkTyp101()
        })
      },
      load: function () {
        this.items = this.participanData.questions[this.currentGroupId]
        if (this.items && this.items.length > 0) {
          this.onGetItem(this.items[this.questionIndex])
        } else {
          this.onGetItem(null)
        }
        try {
          document.getElementsByClassName('simplebar-content-wrapper')[0].scrollTop = 0
        } catch (ee) {

        }
      },
      updateValue: function (items, item) {
        var data = {
          ID_Klausur: this.currentGroupId,
          idItem: item.ID,
          answers: []
        }
        for (var i in items) {
          var iObject = items[i]
          data.answers.push({
            idItem: iObject.ID,
            marker: iObject.Marker,
            column: iObject.Spalte,
            type: iObject.Typ,
            row: iObject.Zeile,
            uniqueId: iObject.uniqueId
          })
        }
        this.checkTyp101()
        Vue.prototype.$apiParticipant.saveAnswer(data, this.onAnswerSuccess, this.onAnswerFailed)
      },
      checkTyp101: function () {
        if (!this.$refs.pItemRoot) return
        let items = this.$refs.pItemRoot.getItemValues()
        let allSelected = true
        for (var i in items) {
          var iObject = items[i]
          try {
            if (iObject.Format === 'ANX') {
              if (!Vue.prototype.$api.stringToBoolean('' + iObject.Marker)) {
                allSelected = false
              }
            }
          } catch (eee) {
            console.error(eee)
          }
        }
        if (this.questionData.Typ === '101') {
          this.forwardEnabled = allSelected
        }
      },
      onPingSuccess: function (item) {
        /*
        this.secRemaining = item.secRemaining
        try {
          this.remainStr = new Date(this.secRemaining * 1000).toISOString().substr(11, 8)
        } catch (e) {
          console.log(e)
        }
         */
      },
      onAnswerSuccess: function (item) {
        try {
          if (item && item.secRemaining) {
            this.secRemaining = item.secRemaining
          }
          if (this.secRemaining) {
            this.remainStr = new Date(this.secRemaining * 1000).toISOString().substr(11, 8)
          }
        } catch (e) {
          console.error(e)
        }
      },
      closeErrorDialog: function (item) {
        this.error = false
        try {
          if (item && item.code === 406) {
            this.close()
          }
        } catch (e) {
          console.error(e)
        }
        try {
          if (item && item.code === 401) {
            this.close()
          }
        } catch (e) {
          console.error(e)
        }
      },
      handleNetworkTodos: function () {
        this.cntTodos = Vue.prototype.$apiParticipant.getCountTodos()
        Vue.prototype.$apiParticipant.checkTodos()
      },
      checkTime: function () {
        this.hasNetworkItem = Vue.prototype.$apiParticipant.hasToDos()
        let diff = 1
        this.secRemaining = this.secRemaining - diff
        if (this.secRemaining <= 0) {
          this.timeLimitReached()
        }
        try {
          this.remainStr = new Date(this.secRemaining * 1000).toISOString().substr(11, 8)
        } catch (e) {
        }
        let cmp = this
        if (cmp.myTimer) {
          window.clearTimeout(cmp.myTimer)
          cmp.myTimer = null
        }
        cmp.myTimer = window.setTimeout(function () {
          cmp.handleNetworkTodos()
          cmp.checkTime(cmp)
        }, 1000)
      },
      timeLimitReached: function () {
        this.secRemaining = 0
        if (this.isTimeLimitReached) {
          return
        }
        this.isTimeLimitReached = true
        this.lastDialog = true
        this.lastDialogCancelAllowed = false
        this.lastDialogTitle = 'Zeitlimit erreicht.'
        this.lastDialogTitleDesc = 'Sie haben das Zeitlimit erreicht, sie können keinen weiteren Fragen beantworten.'
        this.maxToDos = Vue.prototype.$apiParticipant.getCountTodos()
        this.closeOnline()
      },
      onRequestDone: function (result, chainData) {
        // console.log('onRequestDone', result, chainData)
        if (result) {
          try {
            if (result.isOffline) {
              this.lastDialogTitle = 'Klausur ist offline.'
              this.lastDialogTitleDesc = 'Die Klausur ist offlient, sie können keinen weiteren Fragen beantworten.'
              this.maxToDos = Vue.prototype.$apiParticipant.getCountTodos()
              this.closeOnline()
            }
            try {
              this.remainStr = new Date(result.secRemaining * 1000).toISOString().substr(11, 8)
              this.secRemaining = result.secRemaining
              if (this.secRemaining <= 0) {
                this.timeLimitReached()
              }
            } catch (e) {
              console.error(e)
            }
          } catch (ee) {
            console.log(ee)
          }
        }
      },
      onAnswerFailed: function (item, status, error) {
        this.error = true
        try {
          this.remainStr = new Date(item.data.secRemaining * 1000).toISOString().substr(11, 8)
          this.secRemaining = item.data.secRemaining
        } catch (e) {
          console.error(e)
        }

        try {
          if (item.data) {
            this.errorItem = item.data
          } else {
            this.errorItem = {
              message: JSON.stringify(item)
            }
          }
        } catch (e) {
          console.error(e)
        }
      }
    },
    data () {
      return {
        startTm: 0,
        forwardEnabled: false,
        limitLogin: false,
        answeroptions: 6,
        cntTodos: 0,
        lastDialogTitle: 'Letze Frage erreicht',
        lastDialogTitleDesc: '',
        lastDialogCancelAllowed: true,
        lastDialogCancelBtnText: 'Antworten bearbeiten',
        maxToDos: 0,
        Punkte: 0,
        loginAlreadyDoneDialog: false,
        error: false,
        secRemaining: -999,
        hasNetworkItem: false,
        remainStr: '',
        errorItem: null,
        lastDialog: false,
        isTimeLimitReached: false,
        participanData: null,
        items: null,
        questionIndex: 0,
        questionData: null,
        dialog: false,
        itemId: null,
        myTimer: null,
        currentGroupId: -1,
        currentGroup: null,
        tanIsNotActiveDialog: false,
        examNotOnlineDialog: false,
        infoDialog: false,
        contractDialog: false,
        infoDialogNotShown: true,
        userData: {}
      }
    },
    mounted () {
      Vue.prototype.$api.checkCredentials(this)

      this.participanData = Vue.prototype.$apiParticipant.getParticipantData()
      try {
        this.userData = Vue.prototype.$api.getCredentials().data.particiant
      } catch (ee) {

      }

      let cmp = this
      if (cmp.myTimer) {
        window.clearTimeout(cmp.myTimer)
        cmp.myTimer = null
      }
      cmp.startTm = new Date().getTime()
      cmp.myTimer = window.setTimeout(function () {
        cmp.checkTime(cmp)
      }, 1000)

      if (this.participanData === null) {
        this.close()
      } else {
        this.currentGroupId = this.participanData.groupList[0].ID_Klausur
        this.currentGroup = this.participanData.groupList[0]

        try {
          this.limitLogin = Vue.prototype.$api.stringToBoolean(this.currentGroup.options.limitLogin)
        } catch (ee) {
          console.error(ee)
        }

        try {
          this.remainStr = new Date(Vue.prototype.$api.getCredentials().data.secRemaining * 1000).toISOString().substr(11, 8)
          this.secRemaining = Vue.prototype.$api.getCredentials().data.secRemaining
        } catch (e) {
          console.error(e)
        }

        this.load()
      }
    },
    destroyed () {
      Vue.prototype.$eventHub.$off('requestDone', this.onRequestDone)
    },
    created () {
      Vue.prototype.$eventHub.$on('requestDone', this.onRequestDone)
    }
  }
</script>

<style scoped>
  .onlineDisplay {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
    display: table-cell;
    background-color: #FEFEFE;
  }

  .maxOnlineDisplay {
    display: inline-block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    -ms-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%)  translateY(-50%);
    max-width: 1280px;
    max-height: 768px;
  }

  .previewTitleHolder {
    text-align: left;
    position: absolute;
    left: 10px;
    right: 10px;
    top: 10px;
    height: 100px;
    background-color: white;
  }

  .previewHolder {
    padding-top: 10px;
    text-align: left;
    position: absolute;
    left: 10px;
    right: 10px;
    top: 120px;
    bottom: 70px;
    background-color: white;
  }

  .miniTitle2 {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .miniTitle {
    font-size: 4.0vw;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .onlineFooter {
    text-align: left;
    position: absolute;
    left: 10px;
    right: 10px;
    height: 60px;
    bottom: 0px;
    background-color: white;
  }
  .upset {
    padding-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/loginParticipant/online.vue